import AuthoritySkillsCommunication from '~/pages/communication/authoritySkills/libs/components/AuthoritySkillsCommunication'
import { TPageProps } from '~/shared/types/commonTypes'

const AuthoritySkillsCommunicationPage = (props: TPageProps) => (
  <AuthoritySkillsCommunication {...props} />
)

export default AuthoritySkillsCommunicationPage
